import request from './request';

export async function list() {
  return request('GET', '/api/blog-categories');
}

export async function create(
  slug?: string,
  title?: string,
  titleEn?: string,
  titleDe?: string
) {
  return request('POST', '/api/blog-categories', {
    slug,
    title,
    titleEn,
    titleDe,
  });
}

export async function update(
  id: string,
  slug?: string,
  title?: string,
  titleEn?: string,
  titleDe?: string
) {
  return request('POST', `/api/blog-categories/${id}`, {
    slug,
    title,
    titleEn,
    titleDe,
  });
}

export async function remove(id: string) {
  return request('DELETE', `/api/blog-categories/${id}`);
}
